module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step2_Image9.37f8ac12.jpg";